import { TOOLTIP } from '@zocdoc-frontend-common/components-tooltip';

export const REFERRER_TYPE_WIDGET = 'widget';

export const APPOINTMENT_TIME_STRINGS = {
    Edit: 'Edit',
    NoLongerAvailable:
        'The appointment time you selected is no longer available.',
    Oops: 'Oops!',
};

export const TooltipParams = {
    [TOOLTIP.BOTTOM]: {
        tooltipPosition: TOOLTIP.BOTTOM,
        tooltipContentClassName: 'tooltip-bottom',
        dataTest: 'tooltip-bottom',
    },
    [TOOLTIP.RIGHT]: {
        tooltipPosition: TOOLTIP.RIGHT,
        tooltipContentClassName: 'tooltip-right',
        dataTest: 'tooltip-right',
    },
};
